<template>
  <div class="content_container">
    <article v-for="walk in walks" :key="walk.ID">
      <location-card
        @walkSelected="walkSelected"
        :images="walk.JourneyImages[0]"
        :text="walk.Title"
        :id="walk.ID"
        :description="walk.Description"
        :selectedCardId="selectedCardId"
        :mapIsLoaded="mapLoaded"
      ></location-card>
    </article>
  </div>
</template>

<script>
import LocationCard from "./LocationCard.vue";
import walks from ".././config/data.json";

export default {
  props: {
    mapLoaded: null,
  },

  data() {
    return {
      walks: walks,
      selectedCardId: null,
    };
  },

  components: {
    LocationCard,
  },

  methods: {
    walkSelected(id, selectWalk, buttonIsSelected) {
      // TODO: Refactor this. LocationCards should fire zoom to and clicked events, but not control and state. Their 'disabled' class should be applied based on a 'selectedCardId' prop controlled by the sidebar.
      // The sidebar should perform all checks & toggling of button states within the click & zoom handlers fired by the LocationCards, then pass a single clean event up the chain.

      // Control button selection (handle on/off toggle states across multiple disconnected buttons)
      this.selectedCardId =
        selectWalk || id != this.selectedCardId || selectWalk & buttonIsSelected
          ? id
          : null;
      let zoomToWalk =
        !buttonIsSelected || selectWalk & buttonIsSelected ? true : selectWalk;
      this.$emit("walkSelected", id, zoomToWalk);
    },
  },
};
</script>
